import { AdminPage, AdminPageHeader, AdminPageHeading, AdminPageContent } from '@/components/AdminPage';
import { AdminTopBarNavMenuFrame } from '@/imports/ui/admin/layouts/AdminTopBarNavMenuFrame';
import * as React from 'react';

import { AllEvents } from './components/AllEvents';
import { CreationMenu } from './components/CreationMenu';

export const EventsPage: React.FC = () => {
  return (
    <AdminTopBarNavMenuFrame>
      <AdminPage maxWidth="full" mx="auto">
        <AdminPageHeader justifyContent="space-between">
          <AdminPageHeading size="md">Events</AdminPageHeading>
          <CreationMenu />
        </AdminPageHeader>
        <AdminPageContent>
          <AllEvents />
        </AdminPageContent>
      </AdminPage>
    </AdminTopBarNavMenuFrame>
  );
};
